import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/landing/landing').then((m) => m.Landing),
    pathMatch: 'full',
  },
  {
    path: 'services',
    children: [
      {
        path: '',
        redirectTo: 'development',
        pathMatch: 'full',
      },
      {
        path: 'development',
        loadComponent: () =>
          import('./layout/development-landing/development-landing').then(
            (m) => m.DevelopmentLanding
          ),
        pathMatch: 'full',
      },
      {
        path: 'single-service',
        loadComponent: () =>
          import('./layout/single-service/single-service').then(
            (m) => m.SingleService
          ),
        pathMatch: 'full',
      },
      {
        path: 'digital-marketing',
        loadComponent: () =>
          import('./layout/digital-marketing/digital-marketing').then(
            (m) => m.DigitalMarketing
          ),
        pathMatch: 'full',
      },

      {
        path: 'single-digital-service',
        loadComponent: () =>
          import('./layout/single-digital-service/single-digital-service').then(
            (m) => m.SingleDigitalService
          ),
        pathMatch: 'full',
      },
      {
        path: 'bussiness',
        loadComponent: () =>
          import('./layout/bussiness-landing/bussiness-landing').then(
            (m) => m.BussinessLanding
          ),
        pathMatch: 'full',
      },

      {
        path: 'single-bussiness-service',
        loadComponent: () =>
          import('./layout/single-bussiness-service/single-bussiness-service').then(
            (m) => m.SingleBussinessService
          ),
        pathMatch: 'full',
      }
    ],
  },
  {
    path: 'projects',
    loadComponent: () =>
      import('./layout/projects/projects').then(
        (m) => m.Projects
      )
  },
  {
    path: 'single-project/:id',
    loadComponent: () =>
      import('./features/single-project/single-project').then(
        (m) => m.SingleProject
      )
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./layout/about/about').then(
        (m) => m.About
      )
  },
  {
    path: 'blogs',
    loadComponent: () =>
      import('./features/blogs/blogs').then(
        (m) => m.Blogs
      )
  },
  {
    path: 'single-blog',
    loadComponent: () =>
      import('./features/single-blog/single-blog').then(
        (m) => m.SingleBlog
      )
  },
  {
    path: 'careers',
    loadComponent: () =>
      import('./features/careers/careers').then(
        (m) => m.Careers
      )
  },
  {
    path: 'apply-career',
    loadComponent: () =>
      import('./features/apply-career/apply-career').then(
        (m) => m.ApplyCareer
      )
  },

  {
    path: 'contact/us',
    loadComponent: () =>
      import('./layout/contact/contact').then(
        (m) => m.Contact
      )
  },
  {
    path: 'industries',
    children: [
      {
        path: '',
        redirectTo: 'e-commerce',
        pathMatch: 'full',
      },
      {
        path: 'e-commerce',
        loadComponent: () =>
          import('./layout/e-commerce-landing/e-commerce-landing').then(
            (m) => m.ECommerceLanding
          ),
        pathMatch: 'full',
      },
      {
        path: 'medical',
        loadComponent: () =>
          import('./layout/medical-insustry-landing/medical-insustry-landing').then(
            (m) => m.MedicalInsustryLanding
          ),
        pathMatch: 'full',
      },
      {
        path: 'media',
        loadComponent: () =>
          import('./layout/media-industry/media-industry').then(
            (m) => m.MediaIndustry
          ),
        pathMatch: 'full',
      },

      {
        path: 'food-and-beverage',
        loadComponent: () =>
          import('./layout/food/food').then(
            (m) => m.Food
          ),
        pathMatch: 'full',
      },
      {
        path: 'real-estate',
        loadComponent: () =>
          import('./layout/real-estate/real-estate').then(
            (m) => m.RealEstate
          ),
        pathMatch: 'full',
      },

      {
        path: 'fashion',
        loadComponent: () =>
          import('./layout/fashion/fashion').then(
            (m) => m.Fashion
          ),
        pathMatch: 'full',
      },

      {
        path: 'education',
        loadComponent: () =>
          import('./layout/education/education').then(
            (m) => m.Education
          ),
        pathMatch: 'full',
      },

      {
        path: 'custom-solutions',
        loadComponent: () =>
          import('./layout/custom-solutions/custom-solutions').then(
            (m) => m.CustomSolutions
          ),
        pathMatch: 'full',
      },
    ],
  },

];
